import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import emptyData from "../assets/empty.jpg";
import { API_BASE_URL, Simulator } from "../constant";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { favoriList } from "../states/atoms/products";
import { age, DurationCredit, Salary } from "../states/atoms/simulator";
import CondorBrand from "../assets/brands/condor.svg";
import HisenseBrand from "../assets/brands/hisense.svg";
import CristorBrand from "../assets/brands/cristor.svg";
import NardiBrand from "../assets/brands/nardi.svg";
import heartFull from "../assets/icons/heart_filled.svg";
import heartEmpty from "../assets/icons/heart.svg";

function ProductCard({ id, name, namear, images, brand, description, variantes, local, grid = true }) {
    const [favorie, setFavorie] = useRecoilState(favoriList);
    const result_36 = useRef(0);
    const [prixProduit, setPrixProduit] = useState(0);

    const [durationSimulator, setDurationSimulator] = useRecoilState(DurationCredit);
    const [ageSimulator, setAgeSimulator] = useRecoilState(age);
    const [salarySimulator, setSalarySimulator] = useRecoilState(Salary);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (true) {
            result_36.current = Simulator(ageSimulator, salarySimulator, variantes[0]?.price, durationSimulator);
            setPrixProduit(parseInt(result_36.current?.versement[0]?.echp));
        }
    }, []);

    const checkFavori = (refernce) => favorie.some(el => el.refernce === refernce);

    const handleAddFavori = ({ id, name, image, prix, refernce }) => {
        setFavorie([...favorie, { id, name, image, prix, refernce }]);
    };

    const handleDeleteItems = ({ refernce }) => {
        const newList = favorie.filter(element => element.refernce !== refernce);
        setFavorie(newList);
    };

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    if (grid) {
        return (
            <article className="w-full">
                <div className="flex flex-col overflow-hidden rounded-xl border bg-white w-full card hover:shadow-lg transition ">
                    <div className="flex justify-between">
                        <img className="object-contain w-1/3 h-10 p-2" src={brand.name === 'Nardi' ? NardiBrand : brand.name === 'Cristor' ? CristorBrand : brand.name === "Hisense" ? HisenseBrand : CondorBrand} alt='condor' />
                        <a className="h-4 w-4 m-4 hover:scale-150 transform transition-transform duration-300 cursor-pointer" onClick={() => {
                            if (checkFavori(variantes[0]?.reference)) {
                                handleDeleteItems({ refernce: variantes[0]?.reference });
                            } else {
                                handleAddFavori({
                                    id,
                                    name,
                                    name_ar: namear,
                                    image: `${API_BASE_URL}${images[0]?.url}`,
                                    prix: variantes[0]?.price,
                                    refernce: variantes[0]?.reference
                                });
                            }
                        }}>
                            <img className="" src={checkFavori(variantes[0]?.reference) ? heartFull : heartEmpty} alt="Heart" />
                        </a>
                    </div>
                    <a href={`/products/${id}`} className="group relative block h-48 overflow-hidden bg-gray-100 md:h-64">
                        <img src={images.length !== 0 ? `${API_BASE_URL}${images[0]?.url}` : emptyData} loading="lazy" alt={name} className="absolute inset-0 h-full w-full object-contain object-center zoom" />
                    </a>
                    <div className="flex flex-1 flex-col p-4 sm:p-2 info">
                        <p className="text-left my-2 h-12 leading-6 text-black text-sm font-semibold  line-clamp-2">{local === 'fr' ? name : local === 'ar' && namear.length > 1 ? namear : name}</p>
                        <div className={`mt-auto flex items-end justify-between ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                            <div className="flex items-center p-2 px-4 gap-2 bg-primary-color hover:bg-secondary-color transition rounded-xl">

                                <span className="text-white  transition text-sm font-bold">{i18n.language === 'fr' ? `${numberWithCommas(prixProduit)},00 ${t('product.currency')} / ${t('product.months')}` : `${t('product.currency')} ${numberWithCommas(prixProduit)},00 / ${t('product.months')}`}</span>
                            </div>
                            <a className="p-2" href={`/products/${id}`}>
                                <span className="px-2 py-1 text-sm text-gray-500 font-bold">{i18n.language === 'fr' ? 'Détails' : 'تفاصيل'}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </article>
        );
    }

    return (
        <article className={`flex mb-10 border-2 rounded ${i18n.language === 'ar' ? 'flex-row-reverse text-right' : ''}`}>
            <div className="relative h-48 w-10/12 md:w-7/12 lg:w-4/12 overflow-hidden">
                {images.length !== 0 ? (
                    <img
                        alt={name}
                        className="h-full mx-auto rounded bg-white zoom object-contain "
                        src={API_BASE_URL + images[0]?.url}
                    />
                ) : (
                    <img
                        alt={name}
                        className="h-full rounded bg-white zoom object-contain "
                        src={emptyData}
                    />
                )}
            </div>
            <footer className={"w-full lg:w-8/12 flex flex-col gap-3 bg-zinc-400 justify-center capitalize"}>
                <div>
                    <h4 className="font-bold">{local === 'fr' ? name : local === 'ar' && namear.length > 1 ? namear : name}</h4>
                </div>
                <div className={`flex justify-start ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                    <img className="object-contain h-10 p-2" src={brand.name === 'Nardi' ? NardiBrand : brand.name === 'Cristor' ? CristorBrand : brand.name === "Hisense" ? HisenseBrand : CondorBrand} alt='condor' />
                </div>
                <div className={`flex flex-row ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                    <div className="inline-block w-1/5 p-2 px-4 text-white bg-primary-color hover:bg-secondary-color transition rounded-xl">
                        {/* <span className="text-white transition text-sm font-bold">{numberWithCommas(prixProduit)}(,00 Da / Mois)</span> */}
                        {/* {numberWithCommas(prixProduit) + ",00" + t('product.currency') + "/" + t('product.months')} */}
                        <span className="text-white  transition text-sm font-bold">{i18n.language === 'fr' ? `${numberWithCommas(prixProduit)},00 ${t('product.currency')} / ${t('product.months')}` : `${t('product.currency')} ${numberWithCommas(prixProduit)},00 / ${t('product.months')}`}</span>
                    </div>
                </div>
                <div className={`flex ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                    <Link to={`/products/${id}`} className="px-2 py-1 text-sm text-gray-500 font-bold">
                        {t('products.details')}
                    </Link>
                </div>
            </footer>
        </article>
    );
}

ProductCard.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    namear: PropTypes.string.isRequired,
    image: PropTypes.string,
    local: PropTypes.string,
    grid: PropTypes.bool,
};

export default ProductCard;

